export const ConfigsEndpoint = (makeRequest) => {
    return {
        fetchLandingPage(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/landing_page', params, options);
        },
        fetchMedConfirmation(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/med_confirmation', params, options);
        },
        fetchInsurance(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/insurance', params, options);
        },
        fetchMedicalInfo(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/medical_info', params, options);
        },
        fetchTransfer(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/transfer', params, options);
        },
        fetchPhiAuthorization(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/phi_authorization', params, options);
        },
        fetchCreateAccount(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/create_account', params, options);
        },
        fetchOnboardSuccess(params, options) {
            return makeRequest('GET', '/v1/onboarding/configs/onboard_success', params, options);
        },
    };
};
//# sourceMappingURL=configs_endpoint.js.map